require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-ml-lesson-curriculum.json") })
        }
      }, "path---posts-ml-lesson-curriculum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-ml-lesson-curriculum!./.cache/json/posts-ml-lesson-curriculum.json
// module id = 394
// module chunks = 231608221292675